import { Button, Form, Input, theme, Typography } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { InputCurrency } from 'utils/formatting'
import { RightOutlined } from '@ant-design/icons'
import CustomFormItem from '../OpenShift/CustomFormItem'

const { Text } = Typography

const CloseShiftForm = ({ onSubmit, isRequestInputBalanceOnCloseShift, loading }) => {
  const { formatMessage } = useIntl()
  const { token } = theme.useToken()
  const [form] = Form.useForm()

  const initialValues = useMemo(() => {
    const values = { pin: '' }
    if (isRequestInputBalanceOnCloseShift) {
      values.closing_balance = 0
    }
    return values
  }, [isRequestInputBalanceOnCloseShift])

  const formatter = useCallback((str) => str.replace(/[^0-9]/g, ''), [])

  return (
    <Form
      id="closeShiftForm"
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinish={onSubmit}
    >
      {isRequestInputBalanceOnCloseShift && (
        <>
          <CustomFormItem
            name="closing_balance"
            label={
              <Text strong style={{ fontSize: 14 }}>
                {formatMessage({ id: 'input_the_last_cashier_balance' })}{' '}
                <Text type="danger">*</Text>
              </Text>
            }
            rules={[
              {
                validator(rule, value) {
                  if (value > 90000000000) {
                    return Promise.reject(
                      formatMessage({ id: 'financeBanks.maximal_value' }, { value: 90000000000 }),
                    )
                  }

                  if (value < 0) {
                    return Promise.reject(
                      formatMessage({ id: 'financeBanks.minimal_value' }, { value: 0 }),
                    )
                  }
                  return Promise.resolve()
                },
              },
              {
                required: true,
                message: formatMessage({ id: 'please_input_the_last_cashier_balance' }),
              },
            ]}
            getValueFromEvent={(e, floatValue) => floatValue}
            wrapper={
              <span
                style={{
                  position: 'absolute',
                  right: 12,
                  bottom: 0,
                  color: token.colorTextTertiary,
                  fontSize: 20,
                  pointerEvents: 'none',
                  height: 48,
                  display: 'flex',
                  alignItems: 'center',
                  zIndex: 1,
                }}
              >
                💰
              </span>
            }
          >
            <InputCurrency
              style={{
                flex: 1,
                border: 'none',
                background: 'transparent',
                fontSize: 16,
                height: '100%',
                padding: 0,
              }}
              placeholder="0.00"
              allowNegative={false}
            />
          </CustomFormItem>
          <Text type="secondary" style={{ marginTop: 0, marginBottom: 16, display: 'block' }}>
            {formatMessage({ id: 'input_the_last_cashier_balance_desc' })}
          </Text>
        </>
      )}
      <Form.Item
        name="pin"
        rules={[
          {
            required: true,
            message: formatMessage({
              id: 'please_input_the_pin_code',
            }),
          },
        ]}
        label={formatMessage({ id: 'input_yout_pin_code' })}
        style={{ marginTop: 8 }}
      >
        <Input.OTP
          inputType="number"
          length={6}
          autoFocus
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
            width: '100%',
            maxWidth: 300,
            margin: '0 auto',
          }}
          formatter={formatter}
          size="large"
        />
      </Form.Item>

      {/* Close Shift Button */}
      <Button
        type="primary"
        htmlType="submit"
        loading={loading}
        block
        size="large"
        icon={<RightOutlined />}
        iconPosition="end"
        style={{
          height: 48,
          fontSize: 16,
          fontWeight: 600,
          marginTop: 24,
        }}
      >
        {formatMessage({ id: 'close_shift' })}
      </Button>
    </Form>
  )
}

export default CloseShiftForm
